/* OMG interim fix — cart-drawer bundle compare-at price.
 *
 * The standalone bundle-builder products carry their discount as the variant's
 * compare_at_price. The Svelte cart drawer never renders that: one-time lines
 * show no strikethrough (it only strikes when line_price !== final_line_price),
 * and subscription lines show a bogus $0.00 (selling_plan_allocation.compare_at_price
 * comes back 0). This overlay injects the correct struck compare-at on those
 * lines so the minicart matches the PDP.
 *
 * Scope: ONLY touches lines whose product handle is bundle-builder-N-pack.
 * Reversible: delete this asset + its <script> include to remove entirely.
 * Superseded by the real fix (bundles as real line-items + real cart discount),
 * after which the drawer's native strikethrough works and this can be removed.
 */
(function () {
  // pack handle -> compare-at price in cents (mirrors the variant compare_at_price)
  var COMPARE = {
    'bundle-builder-4-pack': 4800,
    'bundle-builder-6-pack': 6000,
    'bundle-builder-8-pack': 9599,
    'bundle-builder-12-pack': 11400
  };

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function fixLine(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/(bundle-builder-\d+-pack)/);
    if (!m || !COMPARE[m[1]]) return;
    var li = a.closest('li');
    if (!li) return;
    var box = li.querySelector('.text-lg.text-right');
    if (!box) return;

    var want = money(COMPARE[m[1]]);
    if (m[1] === 'bundle-builder-4-pack') {
      var paid = box.querySelector('.font-bold');
      var paidCents = paid ? Math.round(Number((paid.textContent || '').replace(/[^0-9.]/g, '')) * 100) : 0;
      if (paidCents >= COMPARE[m[1]]) {
        var oldStrike = box.querySelector('.omg-bundle-compare');
        if (oldStrike) oldStrike.remove();
        return;
      }
    }
    var struck = box.querySelector('.line-through');
    if (struck && struck.textContent.trim() === want) return; // already correct, avoid loop

    if (!struck) {
      struck = document.createElement('span');
      struck.className = 'line-through text-sm omg-bundle-compare';
      struck.style.marginRight = '0.4em';
      var finalSpan = box.querySelector('.font-bold');
      box.insertBefore(struck, finalSpan || box.firstChild);
    }
    struck.textContent = want;
  }

  function scan() {
    try {
      var links = document.querySelectorAll('a[href*="/products/bundle-builder-"]');
      for (var i = 0; i < links.length; i++) fixLine(links[i]);
    } catch (e) { /* no-op */ }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; scan(); });
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  try {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { /* no-op */ }
})();
